// utils/errorLogger/rateLimit.ts - utils/errorLogger.ts split (sub-module rateLimit)



const ERROR_RATE_LIMIT = 50;


const ERROR_RATE_WINDOW = 60000;


export const PRIORITY_CONTEXTS = ['digital_submit_order', 'form_submit_order'];


let errorCount = 0;


let lastResetTime = Date.now();



const NOISE_PATTERNS = [
  'Script error.',
  'window.webkit.messageHandlers',
  'Java exception was raised during method invocation',
  'func sseError not found',
];



export const isNoiseError = (error: Error | string): boolean => {
  const msg = typeof error === 'string' ? error : error.message || '';
  if (NOISE_PATTERNS.some(p => msg.includes(p))) return true;
  const stack = typeof error !== 'string' ? error.stack : undefined;
  if (!stack || stack === '') return true;
  return false;
};



export const canLogError = (): boolean => {
    const now = Date.now();

    if (now - lastResetTime > ERROR_RATE_WINDOW) {
        errorCount = 0;
        lastResetTime = now;
    }

    if (errorCount >= ERROR_RATE_LIMIT) {
        if (import.meta.env.DEV) {
            console.warn('[ErrorLogger] Rate limit reached, skipping error log');
        }
        return false;
    }

    errorCount++;
    return true;
};
